module.exports = __webpack_public_path__ + "static/img/PK6.8291bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK6.jpg
// module id = UGIX
// module chunks = 0